import { render, staticRenderFns } from "./NewPublish.vue?vue&type=template&id=498714bf&scoped=true"
import script from "./NewPublish.vue?vue&type=script&lang=js"
export * from "./NewPublish.vue?vue&type=script&lang=js"
import style0 from "./NewPublish.vue?vue&type=style&index=0&id=498714bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498714bf",
  null
  
)

export default component.exports